class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.config = {
      autorotate: this.dataset.autorotate === 'true',
      autorotateSpeed: parseInt(this.dataset.autorotateSpeed) * 1000,
      moveTime: parseFloat(this.dataset.speed),
      space: 100,
    };

    if (window.innerWidth < 768) {
      this.initOnMobile();
    } else {
      this.initOnDesktop();
    }

    window.addEventListener('resize', () => {
      if (window.innerWidth < 768) {
        this.unload();
        this.initOnMobile();
      } else {
        this.unload();
        this.initOnDesktop();
      }
    });
  }

  initOnDesktop() {
    this.initCarousel();
  }

  initOnMobile() {
    this.initCarousel();
  }

  unload() {
    if (this.flickity && typeof this.flickity.destroy === 'function') {
      this.flickity.destroy();
      this.removeNextPrevListeners();
    }
  }

  initCarousel() {
    if (this.dataset.blockCount == 1) {
      return;
    }

    const slider = this.querySelector('.announcement-slider__slides');
    setTimeout(() => {
      this.flickity = new Flickity(slider, {
        accessibility: true,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        setGallerySize: true,
        autoPlay: this.config.autorotate ? this.config.autorotateSpeed : false,
        cellAlign: 'center',
      });
    });

    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    this.onNextPrevClick = this.handleNextPrevClick.bind(this);
    this.prevButton && this.prevButton.addEventListener('click', this.onNextPrevClick);
    this.nextButton && this.nextButton.addEventListener('click', this.onNextPrevClick);
  }

  removeNextPrevListeners() {
    this.prevButton && this.prevButton.removeEventListener('click', this.onNextPrevClick);
    this.nextButton && this.nextButton.removeEventListener('click', this.onNextPrevClick);
  }

  handleNextPrevClick(event) {
    event.preventDefault();
    const target = event.currentTarget;
    
    if (target.name === 'next') {
      this.flickity && this.flickity.next();
    } else if (target.name === 'previous') {
      this.flickity && this.flickity.previous();
    }
  }
}

customElements.define('announcement-bar', AnnouncementBar); 